var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatorsLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 300,
    viewBox: "0 0 282 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.488 237.906C282.184 213.93 284.064 192.539 274.861 172.456C258.371 136.473 233.264 127.122 216.695 106.246C200.125 85.3693 205.329 64.3569 197.964 40.7169C192.216 22.2649 166.584 1.62181 135.44 1.62212C108.157 1.6224 83.5462 9.6291 66.1807 40.9869C48.8625 71.9332 56.8493 100.37 40.2523 134.109C23.6552 167.848 -0.298749 187.956 1.64433 214.183C3.68186 241.685 30.9361 289.587 71.2077 297.326C103.6 303.551 130.728 279.052 163.331 281.968C195.934 284.884 210.82 285.702 225.274 277.726C245.255 266.7 259.113 257.498 269.488 237.906Z",
    stroke: "white",
    strokeOpacity: 0.32,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorsLasso);
export default __webpack_public_path__ + "static/media/creators-lasso.076e41f3fc979c1cb8b294d4b9ddcdc1.svg";
export { ForwardRef as ReactComponent };